/**
 * Installed Plugins
 *
 * Single source of truth for which plugins are enabled.
 * Both web and Node.js environments use this list.
 * Each plugin imports its own UI components when in browser context.
 */

import type { Plugin } from './Plugin';

// Core plugins (always enabled)
import { dataPlugin } from './data/dataPlugin';
import { audioPlugin } from './audio/audioPlugin';

// Optional plugins
import { elementaryPlugin } from './elementary/elementaryPlugin';
import { tonejsPlugin } from './tonejs/tonejsPlugin';
import { videoPlugin } from './video/videoPlugin';
import { hydraPlugin } from './hydra/hydraPlugin';
import { threejsPlugin } from './threejs/threejsPlugin';
import { polyhedraPlugin } from './polyhedra/polyhedraPlugin';
import { generativePlugin } from './generative/generativePlugin';

import { nodeboxPlugin } from './nodebox/nodeboxPlugin';
import { gridPlugin } from './grid/gridPlugin';


/**
 * Plugins to register on runtime initialization.
 * Order matters - dependencies should come first.
 */
export const installedPlugins: Plugin[] = [
  dataPlugin,
  audioPlugin,       // Depends on dataPlugin (envelope uses DataEndpoint)
  elementaryPlugin,
  tonejsPlugin,
  videoPlugin,
  hydraPlugin,
  threejsPlugin,
  polyhedraPlugin,  // Depends on threejs for ThreeDependencies
  generativePlugin,
  gridPlugin,
 // nodeboxPlugin
];
